import { z } from 'zod/v4-mini';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodTaskMessageLocation = matchingZodObject({
    file: z.string(),
    line: z.optional(z.number()),
    column: z.optional(z.number()),
});
//# sourceMappingURL=TaskMessageLocation.js.map